import React, { useState } from "react";
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { buildApiUrl } from "../utils/api";

function MarketerRegister() {
    const [formData, setFormData] = useState({ name: '', email: '', password: '' });
    const [showPassword, setShowPassword] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(buildApiUrl('/api/marketer/register'), formData);
            localStorage.setItem('token', response.data.token);
            // Redirect to dashboard or quotes page
            navigate('/marketerDetails');
        } catch (error) {
            console.error('Error registering user', error);
        }
    };
    return (
        <>
            <Helmet>
                <title>Marketer Register | 3pl Site</title>
            </Helmet>
            <div className="registerMarketer">
                <h1>Marketer Register Section</h1>
                <div className='container form-detail d-flex justify-content-center align-items-center'>
                    <form onSubmit={handleSubmit} >
                        <h3>Register Now</h3>
                        <input type="text" name="name" placeholder="Name" onChange={handleChange} required />
                        <input type="email" name="email" placeholder="Email" onChange={handleChange} required />
                        <input type={showPassword ? "text" : "password"} name="password" placeholder="Password" onChange={handleChange} required />
                        <div className="d-flex align-items-center">
                            <input
                                type="checkbox"
                                id="showPassword"
                                onClick={() => setShowPassword(!showPassword)}
                            />
                            <label htmlFor="showPassword" className="ms-2" style={{ fontWeight: "bold" }}>
                                {showPassword ? "Hide Password" : "Show Password"}
                            </label>
                        </div>
                        <button type="submit">Register Now</button>
                        <div className='returnHome'>
                            <Link to='/' style={{ textDecoration: "none", color: "#fff" }}><p>Go to Home Page</p></Link>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}
export default MarketerRegister
